<template>
    <div class="nav">
        <div class="container-fluid flex mx-auto">
            <div class="flex align-items-centers">
                <div class="logo-wrapper">
                    <span style="cursor:pointer" @click="openMyLoads()" >
                        <svg xmlns="http://www.w3.org/2000/svg"
                             width="60.783"
                             height="44.448"
                             viewBox="0 0 60.783 44.448"
                             class="logo">
                            <g id="g10" transform="translate(0 1985.089)">
                                <g id="g12" transform="translate(0 -1985.089)">
                                    <path id="path14"
                                          d="M2197.558-1979.166a5.922,5.922,0,0,1-5.922,5.922,5.922,5.922,0,0,1-5.922-5.922,5.922,5.922,0,0,1,5.922-5.922,5.922,5.922,0,0,1,5.922,5.922"
                                          transform="translate(-2136.775 1985.089)"
                                          fill="var(--badge-danger)" />
                                    <path id="path16"
                                          d="M2272-1353.46a9.1,9.1,0,0,1-4.082-.963v30.326h8.163v-30.326a9.1,9.1,0,0,1-4.081.963"
                                          transform="translate(-2217.134 1368.544)" />
                                    <path id="path18"
                                          d="M0-1959.2v43.868H22.928v-8.166H8.163v-35.7H0"
                                          transform="translate(0 1959.775)" />
                                    <path id="path20"
                                          d="M539.332-1953.109c-4.177-4.023-9.62-6.087-17.56-6.087h-12.58v32.463h8.163v-24.347h4.482c4.487,0,8.228.55,10.818,3.343a15.163,15.163,0,0,1,3.73,10.411,15.119,15.119,0,0,1-3.835,10.419c-2.195,2.349-5.136,3.208-8.593,3.413v8.166c6.787-.352,11.608-2.49,15.384-6.134,4.139-4,6.142-9.481,6.142-15.864,0-6.242-2.065-11.848-6.15-15.783"
                                          transform="translate(-497.791 1959.775)" />
                                </g>
                            </g>
                        </svg>
                    </span>
                </div>
                <div>
                    <custom-router-link :class="{ disabled: !userHasPerm('CARRIER.VIEW')}" :to="{ name: 'Carriers Profile', params: { id: 'lookup' }}" newTab>
                        <Button
                            type="button"
                            label="Carrier Lookup"
                            icon="pi pi-search"
                            class="lookup-button ml-6 shadow-3"
                            role="link"
                        />
                    </custom-router-link>    
                    <a href="https://helpdesk.shipldi.com/home" target="_blank">
                        <Button
                            type="button"
                            label="Help Desk"
                            class="helpdesk-button ml-2 shadow-3"
                            role="link"
                        />
                    </a>
                    <custom-router-link :to="{ name: 'Search - Index' }" newTab>
                        <Button
                            type="button"
                            label="Search"
                            class="search-button ml-2 shadow-3"
                            role="link"
                        />
                    </custom-router-link>                 
                </div>
            </div>
            <notification-ribbon @closeAlert="closeAlert()"></notification-ribbon>
            <div class="flex">

                <div v-if="showCreate"  class="flex">
                    <label class="create-label">Create: </label>
                    
                    <div>
                        <custom-router-link :to="{ name: 'Book Edit' }" newTab>
                            <Button
                                type="button"
                                label="FTL"
                                class="ftl-button ml-2 shadow-3"
                                role="link"
                            />
                        </custom-router-link>  
                        <custom-router-link :to="{ name: 'Ltl' }" newTab>
                            <Button
                                type="button"
                                label="LTL"
                                class="ltl-button ml-2 shadow-3"
                                role="link"
                            />
                        </custom-router-link> 
                        <custom-router-link  :to="{ name: 'Intermodal' }" newTab>
                            <Button
                                type="button"
                                label="IML"
                                class="iml-button ml-2 shadow-3"
                                role="link"
                            />
                        </custom-router-link>
                    </div>
                </div>

                <div class="link-wrapper ml-3 mr-3" v-show="isAuthed == true">
                    <ul class="nav-menu hidden  md:flex" ref="mobilemenu">
                        <li class="dropdown-submenu">
                            <a>
                                <span>Menu</span>
                                <svg class="icon-sm ml-2">
                                    <use href="/svg/icons.svg#chevron-down" xlink:href="/svg/icons.svg#chevron-down"></use>
                                </svg>
                            </a>
                            <ul ref="menuDropDown" class="dropdown-menu">
                                <li class="dropdown-submenu cursor-pointer">
                                    <a class="flex align-items-center justify-content-start" @click="toggleMyloadsMenu()">
                                        <span>My Loads</span>
                                        <i v-if="myloadMenuOpen" class="pi pi-angle-up ml-2" aria-hidden="true"></i>
                                        <i v-else class="pi pi-angle-down ml-2" aria-hidden="true"></i>
                                    </a>
                                    <ul ref="MyLoadsDropdownList" class="dropdown-menu-submenu ml-1">
                                        <li>
                                            <custom-router-link :to="{ name: 'My Loads', params: { loadtype: 'Posting' }}" newTab>Posting</custom-router-link>
                                        </li>
                                        <li>
                                            <custom-router-link :to="{ name: 'My Loads', params: { loadtype: 'Available' }}" newTab>Available</custom-router-link>
                                        </li>
                                        <li>
                                            <custom-router-link :to="{ name: 'My Loads', params: { loadtype: 'Covered' }}" newTab>Covered</custom-router-link>
                                        </li>
                                        <li>
                                            <custom-router-link :to="{ name: 'My Loads', params: { loadtype: 'Dispatched' }}" newTab>Dispatched</custom-router-link>
                                        </li>
                                        <li>
                                            <custom-router-link :to="{ name: 'My Loads', params: { loadtype: 'In-Transit' }}" newTab>In-Transit</custom-router-link>
                                        </li>
                                        <li>
                                            <custom-router-link :to="{ name: 'My Loads', params: { loadtype: 'OnHold' }}" newTab>On Hold</custom-router-link>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <custom-router-link :to="{ name: 'EDI 204' }" newTab>EDI</custom-router-link>
                                </li>
                                <li>
                                    <custom-router-link :to="{ name: 'Book Edit' }" newTab>Create FTL</custom-router-link>
                                </li>
                                <li>
                                    <custom-router-link :to="{ name: 'Ltl' }" newTab>Create LTL</custom-router-link>
                                </li>
                                <li>
                                    <custom-router-link :to="{ name: 'Intermodal' }" newTab>Create Intermodal</custom-router-link>
                                </li>
                                <li>
                                    <custom-router-link :to="{name: 'Customer Profile - Index'}" newTab>Customer Profile</custom-router-link>
                                </li>
                                <li>
                                    <a @click.prevent="openCarrierSmartSearch" class="cursor-pointer">Carrier Smart Search</a>
                                </li>
                                <li>
                                    <custom-router-link :to="{name: 'Permissions'}" newTab>Permissions</custom-router-link>
                                </li>
                                <li v-if="HasFeature('DormantCustomerManager')">
                                    <custom-router-link  :to="{ name: 'Dormant Customer Manager' }" >Dormant Customer Manager</custom-router-link>
                                </li>
                                <li>
                                    <custom-router-link :to="{ name: 'Search - Index' }" newTab>Search</custom-router-link>
                                </li>
                                <li>
                                    <custom-router-link :to="{ name: 'ReportsPage' }" newTab>Report Center</custom-router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="flex items-center">
                    <!-- <router-link v-if="isAuthed == false" to="/login" class="log-btn"
                      >Login</router-link
                    > -->
                    <div class="notification-dropdown-wrapper" v-if="isAuthed == true">
                        <section class="dropdown-menu-wrapper"
                                 :class="notificationCount == 0 ? 'no-border' : ''">
                            <button class="dropdown-menu-button" @click="notificationScroll">
                                <svg class="icon fill-svg icon-white">
                                    <use href="/svg/icons.svg#Notification" xlink:href="/svg/icons.svg#Notification"></use>
                                </svg>
                                <div class="circle-wrapper">{{ notificationCount }}</div>
                            </button>
                            <section class="dropdown right" v-show="notificationDropdown">
                                <div class="notification-holder" id="notificationholder">
                                    <section class="option notification-wrapper"
                                             v-for="(notification, index) in notifications"
                                             :key="notification.NotificationID">
                                        <div :class="+notification.Status ? 'read' : 'unread'">
                                            <h3>{{ notification.Subject }}</h3>
                                            <p>{{ notification.BodyText }}</p>
                                            <ldi-dropdown align="left">
                                                <template v-slot:button-content>
                                                    <svg class="icon icon-dots">
                                                        <use href="/svg/icons.svg#dots" xlink:href="/svg/icons.svg#dots"></use>
                                                    </svg>
                                                </template>
                                                <section class="option notification-wrapper"
                                                         @click="read(index)">
                                                    Read
                                                </section>
                                                <section class="option notification-wrapper"
                                                         @click="deleteNotification(index)">
                                                    Delete
                                                </section>
                                            </ldi-dropdown>
                                        </div>
                                    </section>
                                </div>
                                <section v-if="notifications.length > 0" class="clearall">
                                    <span @click="clearall">Clear All</span>
                                    <span @click="readall">Read All</span>
                                </section>
                            </section>
                        </section>
                    </div>
                    <ldi-dropdown align="right">
                        <template v-slot:button-content>
                            <svg class="icon icon-user icon-white">
                                <use href="/svg/icons.svg#user" xlink:href="/svg/icons.svg#user"></use>
                            </svg>
                            <span class="ml-2 username">{{ firstNameStr }}</span>
                        </template>

                        <section v-if="isAuthed == true"
                                 class="option notification-wrapper disabled-hover">
                            LDI Corporate
                        </section>
                        <section v-if="isAuthed == true"
                                 class="option notification-wrapper"
                                 @click="redirectToSettings">
                            Settings
                        </section>
                        <section class="option notification-wrapper" @click="OpenSignOutConfirmationDialog()">
                            Sign Out
                        </section>
                    </ldi-dropdown>
                    <Dialog v-model:visible="SignoutConfirmationFlag"
                            :style="{ width: '450px' }"
                            header="Confirm"
                            :modal="true"
                            class="theme-dialog">
                        <div class="confirmation-content">
                            <span>Are you sure you want to sign out?</span>
                        </div>
                        <template #footer>
                            <button class="theme-btn" @click="logOut">Yes</button>
                            <button class="btn-outline" @click="CloseSignOutConfirmationDialog()()">
                                No
                            </button>
                        </template>
                    </Dialog>
                </div>
            </div>

            <a href="javascript:void(0);"
               class="icon block md:hidden"
               @click="toggleMenu()">
                <svg class="icon">
                    <use href="/svg/icons.svg#menu" xlink:href="/svg/icons.svg#menu"></use>
                </svg>
            </a>
        </div>
    </div>
    <Dialog v-model:visible="showITSdialog"
            :style="{ width: '450px' }"
            header="Login to Truckstop"
            :modal="true"
            class="theme-dialog">
        <div class="confirmation-content">
            <div class="its-login-cont">
                <div>
                    <img src="@/assets/images/truckstop_logo2022.svg" class="truck-stop-logo" />

                </div>
                <div>
                    <div class="flex-cont">
                        <label>Username</label>
                        <input type="text"
                               class="form-control w-170"
                               placeholder="Enter Username"
                               v-model="itsUsername" />
                    </div>
                    <div class="flex-cont">
                        <label>Password</label>
                        <input type="text"
                               class="form-control w-170"
                               placeholder="Enter Password "
                               v-model="itsPassword" />

                    </div>
                    <div> <span>Forgot password? Click </span><a href="https://truckstop.com/" target="_blank">truckstop.com</a></div>

                </div>
            </div>
        </div>
        <div class="its-error-cont" v-if="hasITSLoginError">{{ITSloginError}}</div>
        <template #footer>
            <button class="theme-btn" @click="LoginITS()">Login</button>
            <button class="btn-outline" @click="closeITSLoginDialog()">
                Skip
            </button>
        </template>
    </Dialog>
    <Dialog v-model:visible="openLoad.dialog"
            :style="{ width: '450px' }"
            header="Open a Load"
            :modal="true"
            class="theme-dialog">
        <div class="confirmation-content">
            <div class="flex flex-column">

                <div class="p-inputgroup flex-1 my-1">
                    <span class="p-inputgroup-addon w-8rem bg-black-alpha-10">Load ID</span>
                    <InputNumber ref="openLoadIDInput"
                                 v-model="openLoad.LoadID"
                                 :useGrouping="false"
                                 placeholder="1234567"
                                 @keyup.enter="handleOpenLoad" />
                </div>
                <div v-if="isLoadNotFound" class="text-red-600">*No load found matching that Load ID.</div>
            </div>
        </div>
        <template #footer>
            <button ref="openLoadOpenBtn"
                    class="theme-btn"
                    @click="handleOpenLoad">
                Open
            </button>
            <button class="btn-outline" @click="resetOpenLoad">Cancel</button>
        </template>
    </Dialog>
    <Dialog v-model:visible="settingsDialog"
            :style="{ width: '700px' }"
            header="Settings"
            :modal="true"
            class="theme-dialog settings-dialog">
        <Settings :dialogMode="true" @close="settingsDialog = false" />
    </Dialog>
    <source-load-popup ref="sourceload"></source-load-popup>
</template>
<script>
import { dataProvider } from "@/api/dataProvider";
import NotificationRibbon from "@/components/common/NotificationRibbon.vue";
import InputNumber from "primevue/inputnumber";
import CustomRouterLink from "./CustomRouterLink.vue";
import sourceLoadPopup from "@/components/my-loads/sourceLoadPopup.vue";
import Settings from "@/views/Settings.vue";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showCreate: false,
      myloadMenuOpen : false,
      SignoutConfirmationFlag: false,
      notificationCount: 0,
      notifications: [],
      alerts: [],
      pageNumber: 1,
      readNotificationIds: [],
      notificationDropdown: false,
        showITSdialog: false,
        itsUsername: '',
        itsPassword: '',
        ITSloginError: '',
        hasITSLoginError: false,
        openLoad: {
            dialog: false,
            LoadID: null
        },
        settingsDialog: false

    };
  },
  mounted() {
    this.getNotificationCount();
    this.getNotificationsPageLoad(this.pageNumber, 4);
    document.addEventListener("click", this.close);
    this.getAlerts();

       this.emitter.on("itsCredsShow",()=>{
           this.showITSdialog = true;
    });
    // let createftl = document.querySelector(".create-ftl");
    // createftl.addEventListener("click", (event) => {
    //   event.preventDefault();
    //   alert("Ds");
    // });

      document.addEventListener('keydown', e => {
          if (e.ctrlKey && e.key.toLocaleLowerCase() === 'o') {
              e.preventDefault();
              this.openLoad.dialog = true;
              this.$nextTick(function () { // use non-arrow func for proper this binding (don't replace this with arrow func unless you know what you are doing)
                  this.$refs.openLoadIDInput.$el.querySelector('input').focus();
              });
          }
      });
      this.$refs.menuDropDown.addEventListener('mouseout', (event)=>{
        if (!this.$refs.menuDropDown.contains(event.relatedTarget)) {
            this.hideMyloadsMenu();
        }
      })
  },
  components: {
      NotificationRibbon,
      InputNumber,
      CustomRouterLink,
      sourceLoadPopup,
      Settings,
  },
        methods: {
            toggleMyloadsMenu(){
               this.myloadMenuOpen = !this.myloadMenuOpen
               this.$refs.MyLoadsDropdownList.classList.toggle("submenu-active");
            },
            hideMyloadsMenu(){
                this.myloadMenuOpen = false;
                this.$refs.MyLoadsDropdownList.classList.remove("submenu-active");
            },
            HasFeature(feature){
              

        return  this.$store.state.features.features.includes(feature);
    },
            openCarrierSmartSearch()
            {
                this.$refs.sourceload.openSourceLoadfromMenu();
            },
            async openMyLoads(){
                // BookEdit pages must be unlocked before navigation
                if (this.$route.name === 'Book Edit') {
                    this.emitter.emit("logoClicked");
                } else {
                    if (window.opener) { // If the ref to the original window still exists, close this window
                        window.close();
                    }
                    await this.$router.push({ name: 'My Loads' });
                    window.location.reload(); // Refresh needs to be manually triggered for child routes e.g. my-loads/available
                }
                
                
            },
            async handleOpenLoad() {
                this.isActive = true;
                const res = await dataProvider.IsLoadExists(this.openLoad.LoadID);
                if (res.Data == null) {
                    this.isLoadNotFound = true;
                    this.isActive = false;
                    return;
                }
                this.isLoadNotFound = false;
                const loadType = res.Data.LoadTypeID;
                let url = '';
                switch (loadType) {
                    case 0: // LTL
                        url = `/Ltl/${this.openLoad.LoadID}`;
                        break;
                    case 1: // FTL
                        url = `/book-edit/${this.openLoad.LoadID}`;
                        break;
                    case 2: // Intermodal
                        url = `/intermodal/${this.openLoad.LoadID}`;
                        break;
                    default:
                        this.isLoadNotFound = true;
                        this.isActive = false;
                        break;
                }
                window.open(url, '_blank');
                this.resetOpenLoad();
                this.isActive = false;
            },
            resetOpenLoad() {
                this.$refs.openLoadIDInput.$el.querySelector('input').blur(); // we need to remove focus before hiding dialog or error will be thrown
                this.openLoad = {
                    dialog: false,
                    LoadID: null
                };
                this.isLoadNotFound = false;
            },
      async LoginITS() {

        this.hasITSLoginError = false;

        var portalID = this.$store.state.login.portalID;
        var employeeID = this.$store.state.login.employeeID;

          await dataProvider.loginToITS(employeeID, portalID, this.itsUsername, this.itsPassword)
              .then((res) => {
                  //if succesful login here close dialog
                  if (res.IsSuccessful === true) {
                      this.showITSdialog = false;
                      this.emitter.emit("itsCredsComplete");
                  } else {
                      this.hasITSLoginError = true;
                      this.ITSloginError = JSON.parse(res.Error).error;

                  }
              });

      },
      closeITSLoginDialog() {
          this.showITSdialog = !this.showITSdialog;
          this.emitter.emit("itsCredsComplete");
      },
    OpenSignOutConfirmationDialog(){
      this.SignoutConfirmationFlag = true;
    },
    CloseSignOutConfirmationDialog()
    {
      this.SignoutConfirmationFlag = false;
    },
    async logOut() {
      await this.$store.dispatch('login/logout');
      this.$router.push({path: "/", query: {"l": "so"}});
      return true;
    },
    toggleMenu() {
      this.$refs.mobilemenu.classList.toggle("navbar-collapse");
    },
    redirectToSettings() {
      this.settingsDialog = true;
    },
    async getNotificationCount() {
      let result = await dataProvider.getNotificationCount();
      this.notificationCount = result;
    },
    async getNotifications(pageNumber, pageSize) {
      let result = await dataProvider.getNotifications(pageNumber, pageSize, 5);
      let notificationData = result.notificationData;
      Array.prototype.push.apply(this.notifications, notificationData);
      this.readNotificationIds = this.notifications.map((item) => {
        return item.NotificationID;
      });
      // await dataProvider.updateNotifications(this.readNotificationIds.join());
      return result;
    },
    async getNotificationsPageLoad(pageNumber, pageSize) {
      let result = await dataProvider.getNotifications(pageNumber, pageSize, 5);
      let notificationData = result.notificationData;
      Array.prototype.push.apply(this.notifications, notificationData);
      return result;
    },
    async getAlerts() {
      let result = await dataProvider.getNotifications(this.pageNumber, 4, 2);
      let notificationData = result.notificationData;
      this.alerts = [];
      notificationData.forEach((element) => {
        if (!this.checkDuplicatealerts(element) & (element.Status == false)) {
          this.alerts.unshift(element);
        }
      });
      this.showAlert();
    },
    async notificationRefresh(pageNumber, pageSize) {
      let result = await dataProvider.getNotifications(pageNumber, pageSize, 5);
      let notificationData = result.notificationData;
      if (notificationData.length > 0) {
        notificationData.forEach((element) => {
          if (!this.checkDuplicatealerts(element)) {
            this.notifications.push(element);
          }
        });
      }
    },
    checkDuplicatealerts(element) {
      if (this.alerts.length > 0) {
        for (let i = 0; i < this.alerts.length; i++) {
          if (element.NotificationID == this.alerts[i].NotificationID) {
            return true;
          }
        }
        return false;
      }
    },
    showAlert() {
      if (this.alerts.length > 0) {
        this.$toast.removeGroup("noti");
        let summary = this.alerts[this.alerts.length - 1].Subject;
        this.$toast.add({
          severity: "warn",
          summary: summary,
          group: "noti",
        });
      }
      if (
        (this.alerts.length == 0) &
        (this.pageNumber <= this.notificationCount / 4)
      ) {
        this.pageNumber++;
        this.getNotifications(this.pageNumber, 4);
      }
    },
    async closeAlert() {
      if (this.alerts.length > 0) {
        this.notificationCount = await dataProvider.updateNotifications(
          this.alerts[this.alerts.length - 1].NotificationID,
          "read"
        );

        let notificationIdIndex = this.notifications.findIndex(
          (item) =>
            item.NotificationID ==
            this.alerts[this.alerts.length - 1].NotificationID
        );
        if (notificationIdIndex !== -1) {
          this.notifications[notificationIdIndex].Status = true;
        }
        this.alerts.pop(this.alerts.length - 1);
        this.showAlert();
      }
    },
    notificationScroll() {
      this.notificationDropdown = !this.notificationDropdown;
      var dropdown = document.getElementById("notificationholder");
      dropdown.addEventListener("scroll", () => {
        if (
          dropdown.offsetHeight + dropdown.scrollTop >=
          dropdown.scrollHeight - 3
        ) {
          this.pageNumber++;
          this.getNotifications(this.pageNumber, 4);
        }
      });
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.notificationDropdown = false;
      }
    },
    async read(index) {
      let notificationId = this.notifications[index].NotificationID;
      this.notifications[index].Status = true;
      this.notificationCount = await dataProvider.updateNotifications(
        notificationId,
        "read"
      );
      this.$toast.removeGroup("noti");
      // this.notificationRefresh(this.pageNumber, 4);
      this.getAlerts();
    },
    async deleteNotification(index) {
      let notificationId = this.notifications[index].NotificationID;
      let notificationIdIndex = this.notifications.findIndex(
        (item) =>
          item.NotificationID == this.notifications[index].NotificationID
      );
      this.notificationCount = await dataProvider.updateNotifications(
        notificationId,
        "clear"
      );

      this.notifications.splice(notificationIdIndex, 1);
      this.$toast.removeGroup("noti");
      // this.notificationRefresh(this.pageNumber, 4);
      this.getAlerts();
    },
    async clearall() {
      this.notificationCount = await dataProvider.updateNotifications(
        0,
        "clearall"
      );
      this.notifications = [];
      this.alerts = [];
      this.$toast.removeGroup("noti");
      // this.notificationRefresh(this.pageNumber, 4);
      this.getAlerts();
    },
    async readall() {
      this.notificationCount = await dataProvider.updateNotifications(
        0,
        "readall"
      );
      this.alerts = [];
      this.$toast.removeGroup("noti");
      this.notifications.forEach((item) => {
        item.Status = true;
      });
      // this.notificationRefresh(this.pageNumber, 4);
      this.getAlerts();
    },
    openCreateLoad() {
      // this.$store.commit("login/openCreateLoad");
    },
  },
  watch: {
    '$route.name': function(newVal)
    {
        if (newVal !== 'My Loads' && newVal !== 'Book Edit' && newVal !== 'Ltl' && newVal !== 'Intermodal') this.showCreate = true;
        else this.showCreate = false;
    }

  },
  computed: {
    isAuthed() {
        return this.$store.getters['login/isAuthenticated'];
    },
    firstNameStr() {
      var firstNameStr = this.$store.state.login.firstName;
      if (firstNameStr != null && firstNameStr != "") {
        firstNameStr = firstNameStr.toLocaleLowerCase();
      }
      return firstNameStr;
    },
    ...mapGetters('login', [
        'userHasPerm'
    ])
  },

  beforeUnmount() {
    document.removeEventListener("click", this.close);
  },
};
</script>
<style lang="scss">

  .nav {
    background: var(--accent-primary);
    color: var(--text-accent-primary);

    .logo-wrapper {
      .logo {
          width: 60px;
          fill: var(--logo-fill-primary);
      }
    }


    .create-label {
        font-size: 14px;
        color: var(--text-accent-primary);
    }

    @mixin action-button($bg) {
        background: $bg;
        color: var(--text-button);
        border: 1px solid var(--border-button);

        .p-button-icon::before {
            font-size: 14px;
            color: var(--text-button);
        }

        &:hover,
        &:focus {
            background: $bg !important;
            color: var(--text-button) !important;
            border-color: var(--border-button) !important;
            outline: none !important;
        }
    }

    .lookup-button,
    .ftl-button {
        @include action-button(var(--button-primary-bg));
    }

    .helpdesk-button,
    .ltl-button {
        @include action-button(var(--button-secondary-bg));
    }

    .iml-button{
        @include action-button(var(--badge-success));
    }

    .search-button{
        @include action-button(var(--button-tertiary-bg))
    }

    .dropdown-menu-button {
      padding: 8px 10px !important;
      border: none !important;
      transition: all 0.2s ease-in;

      &:hover {
        opacity: 0.8;
      }

      .username {
        text-transform: capitalize;
        color: var(--text-accent-primary);
      }

      .icon {
        fill: var(--icon-fill-primary);
      }

      .circle-wrapper {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: var(--icon-fill-primary) 1.5px solid;
        color: var(--icon-fill-secondary);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        position: absolute;
        top: 0px;
        right: 4px;
      }
    }
    
  }

  .nav-menu li.dropdown-submenu .dropdown-menu li a,
  .nav .dropdown-menu-wrapper .dropdown .option {
            border-bottom: 1px solid var(--nav-submenu-border);
  }

  .nav-menu {
    li {
      a {
        display: inline-flex;
        align-items: center;
        justify-content: start;
        padding: 8px 12px;
        width: 100%;
        transition: all 0.2s ease-in;
        color: var(--text-accent-primary);

        &:hover {
          background: color-mix(in srgb, var(--accent-primary), black 10%);
        }

        &.router-link-exact-active {
          span {
            display: inline-block;
            padding: 4px 0;
            font-weight: 500;
            border-bottom: 2px solid #e74c42;
          }
        }
      }

      &.dropdown-submenu {
        position: relative;
        display: block;

        .dropdown-menu {
          display: none;
          position: absolute;
          min-width: 170px;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.2);
          z-index: 10;
          background: var(--nav-submenu-bg);

          li {
            a {
              background: var(--nav-submenu-bg);
              color: var(--text-accent-primary);
              padding-left: 21px;

              .icon-sm {
                transform: rotate(-90deg);
              }

              &:hover {
                background: rgba(0, 0, 0, 0.2);
              }
            }

            .dropdown-menu {
              left: 100%;
              top: 0;
              opacity: 0;
              transition: all 0.2s ease-in;

              li {
                a {
                  background: var(--nav-submenu-bg);
                  color: var(--text-accent-primary);

                  &:hover {
                    background: rgba(0, 0, 0, 0.2);
                  }
                }
              }
            }

            &:hover {
              .dropdown-menu {
                opacity: 1;
              }
            }
          }
        }

        &:hover {
          .dropdown-menu {
            display: block;
          }
        }
      }
    }

    &.navbar-collapse {
      display: block !important;
      position: absolute;
      left: 0;
      width: 100%;
      background: var(--nav-submenu-bg);
      top: 60px;
    }
  }











    


    .its-error-cont{
        display:flex;
        justify-content:center;
        color: var(--badge-danger); // CHECK COLOR
        padding:15px;
    }
    .flex-cont label {
        margin-right: 5px
    }
        .flex-cont {
            display: flex;
            justify-content: space-between;
            flex-direction: unset;
            align-items: center;
            padding: 5px
        }

        .its-login-cont {
            display: flex;
        }

        .truck-stop-logo {
            width: 10rem;
            padding: 10px
        }

        .nav {
            padding: 15px 0;
            box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.2);

            .flex {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

  

            



            .notification-dropdown-wrapper {
                .dropdown {
                    padding: 0;

                    .notification-holder {
                        min-width: 230px;
                        height: auto;
                        max-height: 170px;
                        overflow-x: hidden;
                        overflow-y: scroll;
                        padding: 0;

                        .option {
                            padding: 0;
                            // background: #046a7e;
                            border-bottom: 1px solid var(--nav-submenu-border);
                            transition: all 0.2s ease-in;

                            div {
                                padding: 6px 10px;
                                position: relative;
                            }

                            .read {
                                h3 {
                                    font-weight: 400;
                                    color: var(--text-bg-page); // CHECK COLOR
                                }

                                p {
                                    color: var(--text-bg-page); // CHECK COLOR
                                    font-weight: 400;
                                }
                            }

                            .unread {
                                h3 {
                                    font-weight: 500;
                                }

                                p {
                                    font-weight: 500;
                                }
                            }

                            h3 {
                                font-size: 14px;
                                margin-bottom: 5px;
                            }

                            p {
                                font-size: 11px;
                            }

                            .dropdown-menu-wrapper {
                                position: static;
                            }

                            .dropdown-menu-button {
                                position: absolute;
                                right: 3px;
                                top: 0px;
                                display: inline-block;
                                height: auto;
                            }

                            .dropdown {
                                top: 20px;
                                right: 12px;
                                background: transparent;
                                min-width: auto;

                                .menuArrow {
                                    display: none;
                                }

                                .option {
                                    width: 50px;
                                    background: var(--bg-primary); // CHECK COLOR
                                    color: var(--text-accent-primary);
                                    padding: 4px 8px;
                                    font-size: 10px;
                                }
                            }
                            // &:hover {
                            //   background: rgba(0, 0, 0, 0.2);
                            //   box-shadow: 0px 2px 7px #ced4e2c2;
                            // }
                        }

                        a {
                            color: var(--text-accent-primary);

                            &:hover {
                                text-decoration: underline;
                            }
                        }
                    }

                    .clearall {
                        padding: 4px 10px;
                        display: flex;
                        justify-content: space-between;
                        font-size: 13px;
                        color: var(--text-accent-primary);

                        span {
                            cursor: pointer;
                        }
                    }
                }



                .dropdown-menu-button {
                    &:after {
                        display: none;
                    }
                }
            }



            .dropdown-menu-wrapper {
                .dropdown {
                    background: var(--nav-submenu-bg);

                    .option {
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        background: var(--nav-submenu-bg);
                        color: var(--text-accent-primary);

                        .icon-wrapper {
                            width: 35px;
                            height: 35px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-right: 10px;
                        }

                        h3 {
                            font-size: 13px;
                            font-weight: 500;
                            width: 90%;
                        }

                        p {
                            font-size: 12px;
                        }

                        .icon-dots {
                            width: 15px;
                            height: 15px;
                        }
                    }

                    .header {
                        display: flex;
                        justify-content: space-between;
                        padding: 5px 15px;
                        font-size: 14px;
                        color: var(--text-accent-primary);
                        border-bottom: 1px solid var(--border-accent); // CHECK COLOR
                    }

                    .all-msg {
                        padding: 5px 15px;
                        font-size: 14px;
                        color: var(--text-accent-primary);
                    }

                    &.right {
                        .menuArrow {
                            background: var(--nav-submenu-bg);
                            border: none;
                        }
                    }
                }

                .dropdown-menu-button {
                    &:after {
                        display: none;
                    }
                }
            }
        }





        .log-btn {
            background: var(--button-primary-bg); // CHECK COLOR
            color: var(--text-button); // CHECK COLOR
            width: 200px;
            padding: 8px 35px;
            font-size: 14px;
            text-transform: uppercase;
            border-radius: 4px;
            margin-bottom: 20px;
            transition: all 0.3s ease-in-out;
        }



        .dropdown-menu-wrapper .dropdown .option.notification-wrapper:hover {
            background: rgba(0, 0, 0, 0.2);
        }

        .nav .dropdown-menu-wrapper .dropdown .option:hover.disabled-hover:hover {
            background: transparent;
            cursor: default;
        }


        
        .p-2px{
            padding: 2px;
        }

    .dropdown-menu-submenu {
        display: none !important;
        
        li {
            a {
            &::before {
                content: "-" !important;
                margin-right: 5px !important;
            }
            padding-left: 30px !important;
            }
        }
        }

        .submenu-active {
            display: block !important;
        }

</style>
